import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyxLight, silverChalice, white} from '/theme/color/on.color';
import {alto, codGray, mineShaft} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  rootContainer: {
    marginBottom: indent,
  },
  heading: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    paddingBottom: indent * 0.25,
  },
  subHeading: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    flexShrink: 1,
    alignItems: 'center',
  },
  daysLeft: {
    alignSelf: 'center',
    marginLeft: indent * 0.25,
    fontSize: 12,
  },
  progressBarContainer: {
    flexDirection: 'row',
    marginVertical: indent * 0.6,
    alignItems: 'center',
  },
  bonusProgressContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginHorizontal: 8,
  },
  fqvContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginVertical: indent * 0.3,
    flexWrap: 'wrap',
    rowGap: indent * 0.25,
  },
  bonusContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: 0,
    marginVertical: indent * 0.3,
    flexWrap: 'wrap',
    rowGap: indent * 0.25,
  },
  lowerIntermediateBBB: {
    flex: 1,
    textAlign: 'center',
  },
  higherIntermediateBBB: {
    flex: 1,
    textAlign: 'center',
  },
  maximumBBB: {
    flex: 1,
    textAlign: 'center',
  },
  fqvMargin: {
    flex: 1,
    textAlign: 'center',
  },
  maximumFQV: {
    ...getFontFamily('normal'),
    fontSize: 12,
    color: onyxLight,
    width: '100%',
  },
  fqvText: {
    fontWeight: 'bold',
    fontSize: Platform.select({android: 12, ios: 14}),
    color: mineShaft,
    flexShrink: 1,
    marginTop: indent * 0.1,
  },
  boxTitle: {
    marginTop: indent * 0.4,
  },
  dateText: {
    fontSize: Platform.select({android: 12, ios: 14}),
  },

  progressBar: {
    borderRadius: 4,
    justifyContent: 'center',
    height: 6,
    marginHorizontal: 1,
  },
  coachesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    borderRadius: indent * 0.6,
    marginVertical: indent * 0.5,
    width: '100%',
    marginTop: indent - 5,
    flexWrap: 'wrap',
  },
  coachesCountContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  coachesText: {
    padding: indent * 0.7,
    color: codGray,
    flexShrink: 1,
    ...getFontFamily('regular'),
  },
  coachesCount: {
    color: codGray,
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type '"normal" ... Remove this comment to see the full error message
    fontWeight: 700,
    marginRight: indent * 0.25,
  },
  arrowIcon: {
    color: silverChalice,
    fontSize: 24,
    alignSelf: 'center',
    marginRight: indent * 0.2,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  boldText: {
    color: codGray,
    ...getFontFamily('bold'),
  },
});
